import React, { Component } from 'react';
import { Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';

import CustomModal from "../../../components/Modal/CustomModal";

import { DeleteAut } from "../../../funciones/PreferenciasFunction";

class AutoridadesTable extends Component {
    state = {
        openDelAut: false,
        boton1: {
            text: "Si",
            icon: "fa fa-check"
        },
        boton2: {
            text: "No",
            icon: "fa fa-times"
        }
    }

    componentWillReceiveProps = (props) => {
        this.setState({
            openDelAut: false
        })
    }

    delAut = () => {
        let  { boton1, boton2 } = this.state;

        let contenidoModal = <div>
            ¿Desea realmente eliminar esta <strong>Autoridad Educativa</strong> del Sistema?
            </div>
        return (
            <CustomModal
                isopen =  {this.state.openDelAut}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal}
                boton1 = {<React.Fragment><i className= {boton1.icon}></i> {boton1.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className= {boton2.icon}></i> {boton2.text}</React.Fragment>}
                funcion1 = {() => { 
                    this.setState({
                        boton1: {
                            text: "Espera",
                            icon: "fa fa-spinner fa-spin"
                        }
                    }, () => {
                        DeleteAut(this.props.data.id, () => {
                            toast.info("La autoridad fue eliminada exisosamente",{autoClose: 4000});
                            this.props.funcion2()
                            this.setState({
                                openDelAut: false
                            })   
                        })
                    })
                }
            }/>
        );
    }

    render() {
        const styles = {
            padding: 5, fontSize: 12
        }
        let { data } = this.props;
        
        let nombreCompleto = `${data.aut_name} ${data.aut_ape}`

        let openModal = (id, ci, nombre, apellido, tipo, tname) => (e) => {
            let contenido = {
                id: id,
                ci: ci,
                nombre: nombre,
                apellido: apellido,
                tipo: tipo,
                tname: tname
            }

            this.props.funcion(contenido)
        }

        let acciones = (id, ci, nombre, apellido, tipo, tname) => (
            <Popover bsSize="large" id="acciones">
                <div className="text-warning" onClick={openModal(id, ci, nombre, apellido, tipo, tname)} style={{cursor:"pointer", fontSize: 13, padding: 5}} title="Esta opcion permite editar los datos de esta autoridad"><i className="fa fa-edit"></i> Editar Datos</div>
                <div className="text-danger" onClick={() => this.setState({openDelAut: true})} style={{cursor:"pointer", fontSize: 12, padding: 5}} title="Esta opción permite eliminar los datos de esta auroridad"><i className="fa fa-trash"></i> Eliminar Datos</div>
            </Popover>
        )

        return (
            <React.Fragment>
                <tr>
                    <td align="center" style={styles}>{data.cedula}</td>
                    <td style={styles}>{nombreCompleto}</td>
                    <td style={styles}>{data.type_name}</td>
                    <td align="center" style={styles}>
                        <OverlayTrigger trigger="focus" placement="right" overlay={
                            acciones(data.id, data.cedula, data.aut_name, data.aut_ape, data.tipo_aut, data.type_name)
                        }>
                            <button className="btn btn-primary" style={{borderWidth: 1}} title="Acciones para esta registro"><i className="fa fa-gear"></i></button>
                        </OverlayTrigger>
                    </td>
                </tr>
                {this.delAut()}
            </React.Fragment>
        );
    }
}
 
export default AutoridadesTable;


// WEBPACK FOOTER //
// ./src/views/Registros/PreferenciasContent/AutoridadesTable.jsx